import geolib from 'geolib';
import _ from 'underscore';
import { convertMetersToMiles } from './distance';
import { titleize } from 'underscore.string';
import tariffs from './drayage-tariffs';
import { humanize } from 'underscore.string';
const getTariffByMarket = (market) => {
    return new Promise((resolve, reject) => {
        if (!tariffs[market])
            return reject(new Error("NO_TARIFF_FOUND"));
        return resolve(tariffs[market]);
    });
};
const getAccessorialCost = (accessorial) => {
    const accessorialRates = {
        overweight: 150,
        hazmat: 150,
        reefer: 150,
    };
    return accessorialRates[accessorial] || 0;
};
const getAccessorialCosts = (baseCost, accessorials = []) => {
    return new Promise((resolve, reject) => {
        const payables = [{
                type: "base_cost",
                category: "base_cost",
                adjusted_item: "base_cost",
                message: "Base Cost",
                type: "Base Cost",
                processed: false,
                silent: false,
                value: baseCost,
            }];
        const cost = _.reduce(accessorials, (memo, accessorial) => {
            const value = getAccessorialCost(accessorial);
            payables.push({
                type: "customer_adjustment",
                category: "accessorials",
                adjusted_item: "accessorial",
                message: `${humanize(accessorial)}`,
                type: accessorial,
                processed: false,
                silent: false,
                value,
            });
            return memo + value;
        }, 0);
        return resolve({ payables, cost });
    });
};
const getMileageBand = (distance, tariff) => {
    return new Promise((resolve, reject) => {
        if (!distance) {
            return reject(new Error("MISSING_DISTANCE"));
        }
        if (_.isEmpty(tariff)) {
            return reject(new Error("MISSING_TARIFF"));
        }
        const item = _.find(tariff.prices, (item) => {
            return item.start <= distance && distance <= item.end;
        });
        if (!item)
            return reject("MISSING_MILEAGE_BREAK");
        return resolve(item);
    });
};
const getBaseCost = (mileageBand, miles) => {
    return new Promise((resolve, reject) => {
        const mileageCost = mileageBand.rpm * miles;
        const cost = mileageBand.min > mileageCost ? mileageBand.min : mileageCost;
        return resolve(cost);
    });
};
const getDistance = (a, b) => {
    return geolib.getDistance(a, b);
};
const determineMarket = (origin = {}) => {
    return new Promise((resolve, reject) => {
        if (_.isEmpty(origin))
            return reject(new Error("MISSING_ORIGIN_COORDS"));
        const keys = Object.keys(tariffs);
        const results = keys.map(key => {
            return {
                distance: getDistance(tariffs[key].coords, origin.coords),
                market: key,
            };
        });
        const closest = _.sortBy(results, 'distance');
        const market = _.first(closest).market;
        return resolve(market);
    });
};
export const getContainerSizes = () => {
    return [{
            size: "20ft",
        }, {
            size: "40ft",
        }, {
            size: "53ft",
        }];
};
export const getContainerTypes = () => {
    return [{
            name: "ISO Dry",
        }];
};
export const getMovementTypes = () => {
    return [{
            name: "Live Unload",
        }, {
            name: "Drop & Hook",
        }];
};
export const getTariffs = () => {
    return tariffs;
};
export const getLocations = () => {
    return _.map(getTariffs(), (t, key) => {
        return {
            address: t.address,
            coords: t.coords,
            lat: t.lat,
            lng: t.lng,
            name: key,
            label: t.name,
        };
    });
};
export const getPrice = (data = {}) => {
    return new Promise(async (resolve, reject) => {
        try {
            const { distance, accessorials, origin: { name } } = data;
            const distanceInMiles = Math.round(convertMetersToMiles(distance)); // Nearest whole
            const tariff = await getTariffByMarket(name).catch(reject);
            const mileageBand = await getMileageBand(distanceInMiles, tariff).catch(reject);
            const baseCost = await getBaseCost(mileageBand, distanceInMiles).catch(reject);
            const { cost: accessorialCost, payables } = await getAccessorialCosts(baseCost, accessorials).catch(reject);
            const totalCost = parseFloat((baseCost + accessorialCost).toFixed(2));
            const result = { tariff, mileageBand, baseCost, accessorialCost, totalCost, distanceInMeters: distance, distanceInMiles, accessorials, payables };
            return resolve(result);
        }
        catch (e) {
            reject(e);
        }
    });
};
